import type { ChipProps } from '@side/pantry';
import { GQLIdentityTeamStatus } from 'src/generated/graph-api';

export const TEAM_SELECTABLE_STATUSES: ReadonlySet<GQLIdentityTeamStatus> =
  new Set([
    GQLIdentityTeamStatus.ACTIVE,
    GQLIdentityTeamStatus.DRAFT,
    GQLIdentityTeamStatus.ONBOARDING,
  ]);

export const isSelectableTeamStatus = (
  status: GQLIdentityTeamStatus | string | null | undefined,
): boolean =>
  !!status && TEAM_SELECTABLE_STATUSES.has(status as GQLIdentityTeamStatus);

export const TEAM_STATUS_LABEL: Record<GQLIdentityTeamStatus, string> = {
  [GQLIdentityTeamStatus.ACTIVE]: 'Active',
  [GQLIdentityTeamStatus.DRAFT]: 'Draft',
  [GQLIdentityTeamStatus.ONBOARDING]: 'Onboarding',
  [GQLIdentityTeamStatus.OFFBOARDING]: 'Offboarding',
  [GQLIdentityTeamStatus.INACTIVE]: 'Inactive',
};

export const TEAM_STATUS_COLOR: Record<
  GQLIdentityTeamStatus,
  ChipProps['color']
> = {
  [GQLIdentityTeamStatus.ACTIVE]: 'success',
  [GQLIdentityTeamStatus.DRAFT]: 'default',
  [GQLIdentityTeamStatus.ONBOARDING]: 'info',
  [GQLIdentityTeamStatus.OFFBOARDING]: 'warning',
  [GQLIdentityTeamStatus.INACTIVE]: 'error',
};

const isKnownTeamStatus = (status: string): status is GQLIdentityTeamStatus =>
  status in TEAM_STATUS_LABEL;

export const getTeamStatusLabel = (
  status: GQLIdentityTeamStatus | string | null | undefined,
): string =>
  status && isKnownTeamStatus(status) ? TEAM_STATUS_LABEL[status] : 'Inactive';

export const getTeamStatusColor = (
  status: GQLIdentityTeamStatus | string | null | undefined,
): ChipProps['color'] =>
  status && isKnownTeamStatus(status) ? TEAM_STATUS_COLOR[status] : 'error';
